import React from "react";
import { withTranslation } from "react-i18next";
import { relative } from "path";
import { Link } from "react-router-dom";
import { tools } from "@mitim/react-mitim";
import "./SlideTemplate1.scss";

const LogoCalvinEdition = props => (
	<svg
		width={props.width || 40}
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 1279.93 296.13"
	>
		<defs>
			<style
				dangerouslySetInnerHTML={{
					__html:
						".logoCalvinEdition12{fill:none;}.logoCalvinEdition22{clip-path:url(#cplogoCalvinEdition2);}.logoCalvinEdition32{fill:" +
						props.color +
						";}"
				}}
			/>
			<clipPath id="cplogoCalvinEdition2" transform="translate(-0.07 -358.02)">
				<rect
					className="logoCalvinEdition12"
					x="0.07"
					y="358.02"
					width="1279.93"
					height="296.13"
				/>
			</clipPath>
		</defs>
		<g className="logoCalvinEdition22">
			<path
				className="logoCalvinEdition32"
				d="M10,402.15a11,11,0,0,0,1.07,4.93A8.23,8.23,0,0,0,14,410.44a7.34,7.34,0,0,0,4.09,1.21,6.1,6.1,0,0,0,3.62-1,8.77,8.77,0,0,0,2.4-2.5,38.09,38.09,0,0,0,2.12-3.86,21.75,21.75,0,0,1,2.53-4.41,3.72,3.72,0,0,1,3.06-1.46,4.48,4.48,0,0,1,2.41.71,5,5,0,0,1,1.82,2,6.76,6.76,0,0,1,.68,3.07A10.27,10.27,0,0,1,36,407.9a10.57,10.57,0,0,1-2.29,3.52l.22.5,3.73.45a15,15,0,0,0,1.52-3.84,16.14,16.14,0,0,0,.53-4,11.12,11.12,0,0,0-1.14-5.09A8.66,8.66,0,0,0,35.48,396a7.57,7.57,0,0,0-4.18-1.23,6.11,6.11,0,0,0-3.63,1.07,9.32,9.32,0,0,0-2.48,2.57,33,33,0,0,0-2.12,3.95c-.63,1.31-1.18,2.34-1.63,3.09a7.15,7.15,0,0,1-1.62,1.89,3.34,3.34,0,0,1-2.16.75,4.32,4.32,0,0,1-2.27-.66,4.82,4.82,0,0,1-1.77-1.91,6,6,0,0,1-.68-2.93,8.46,8.46,0,0,1,.54-2.93A10.65,10.65,0,0,1,15,396.88l-.18-.65-3.5-.59A17.34,17.34,0,0,0,10,402.15m.14,23.63.27,3.41,23.14,0v.32l-23.32,15v3.78l20.5-.09,8.64.13v-3.27l-9.59.05L16,445.06v-.23l23.32-15.09v-3.82L30.8,426Zm2.77,48.42c0-3,1-5.19,3-6.66s5-2.21,9-2.21q12,0,12,9.1a7.74,7.74,0,0,1-3,6.66q-3,2.21-9.23,2.2-11.73,0-11.73-9.09m-3-.22q0,6.27,3.91,9.65T25,487c4.69,0,8.32-1.07,10.86-3.21s3.82-5.17,3.82-9.11q0-6.31-4-9.73t-11.48-3.41q-6.91,0-10.59,3.21T9.94,474m.27,25.5v3.72L30.58,503l8.77.22v-3.68l-9.09.18Zm0,16.45v19.78L13,536l.36-.23-.27-5.18v-3l17.46-.22,8.77.27V524l-9.09.13L13.12,524v-3l.27-5.09-2.82-.27Zm0,31.91v3.73l20.37-.23,8.77.23v-3.68l-9.09.18Zm26.37,30.28c0,.73,0,1.75-.07,3.07s-.12,2.45-.21,3.38l-6,.14-17-.18q-.19-3.72-.19-6.59,0-9.42,11.46-9.41c4,0,7,.83,9,2.47a8.69,8.69,0,0,1,3,7.12M10,577.67l.18,10.5v0L30.58,588l8.77.23v0c.09-1.52.16-3.16.2-4.94s.07-3.27.07-4.52c0-4.49-1.36-7.92-4.09-10.32s-6.65-3.59-11.78-3.59q-6.63,0-10.18,3.32T10,577.67m-10,26.91c1.55,2.6,3.1,5.5,4.68,8.68l1.64-.64.18-.41q-1.91-4.59-3.91-8.91l-.36-.09-2.14.91ZM36.17,601l.18,7-.05,5.77-6,.14-4.33,0,0-5.18.09-5.09-2.82-.32-.32.27.14,4.82-.09,5.46-9.54-.09-.09-5.78.13-6.86-2.82-.28-.36.19V617.4l20.37-.23,8.77.23V601l-2.82-.27Z"
				transform="translate(-0.07 -358.02)"
			/>
			<path
				className="logoCalvinEdition32"
				d="M1128.47,536.79"
				transform="translate(-0.07 -358.02)"
			/>
			<path
				className="logoCalvinEdition32"
				d="M1262.18,478q0-16-8.42-23.09t-23.65-7.09a53.62,53.62,0,0,0-26.38,6.39,61.75,61.75,0,0,0-19.28,16.3l0-20.66h-45.17v11.54q17.41,0,17.42,9.12v61.77q0,9.12-17.42,9.12V553H1198V541.44q-13.58,0-13.57-9.12V490.6a49.94,49.94,0,0,1,14.78-19.24,39.2,39.2,0,0,1,9.83-5.67,28.32,28.32,0,0,1,10.43-2,12.89,12.89,0,0,1,10.93,5.47q4.05,5.47,4.05,18.23v45q0,9.12-13.57,9.12V553H1280V541.44q-17.82,0-17.82-9.12Z"
				transform="translate(-0.07 -358.02)"
			/>
			<path
				className="logoCalvinEdition32"
				d="M1023.34,437.89a14.41,14.41,0,0,0-10.54-4.4,14.81,14.81,0,0,0-10.63,4.31,14.79,14.79,0,0,0-3.25,16.51,15.65,15.65,0,0,0,8,8,14.84,14.84,0,0,0,16.51-3.25,14.83,14.83,0,0,0,4.31-10.63,14.39,14.39,0,0,0-4.39-10.54m2.28,40.05H986.44v10q15.12,0,15.11,8.08v53.41q0,7.89-15.11,7.9v10h54.46v-10q-15.63,0-15.28-7.9Z"
				transform="translate(-0.07 -358.02)"
			/>
			<path
				className="logoCalvinEdition32"
				d="M888.12,455.72H849.65v10h6.67q7.56,0,7.56,4.75a5.52,5.52,0,0,1-.71,2.8L839.46,530.2,816.1,471.88a6.94,6.94,0,0,1-.53-2.81c0-2.22,1.69-3.34,5.09-3.34h9.48v-10H779.2v10q9.66,0,12.3,6.15l30.21,73.25h22.67l30.21-73.43a8.35,8.35,0,0,1,4.83-4.48,22.8,22.8,0,0,1,8.7-1.49Z"
				transform="translate(-0.07 -358.02)"
			/>
			<path
				className="logoCalvinEdition32"
				d="M665.59,432.79H626.42v10q15.11,0,15.11,7.9v99.42q0,7.92-15.11,7.91v10h54.45V558q-15.27,0-15.28-7.91Z"
				transform="translate(-0.07 -358.02)"
			/>
			<path
				className="logoCalvinEdition32"
				d="M486.63,520.54a30.82,30.82,0,0,1-26.17,14.23q-9,0-13.35-3.52t-4.39-9.83a14.29,14.29,0,0,1,2.63-8.79,22.31,22.31,0,0,1,8.09-6.23,79.34,79.34,0,0,1,13.7-5.09q8.25-2.38,19.49-5.19Zm23-35.95q0-9.51-3.43-15.76A26.26,26.26,0,0,0,497,459a39.61,39.61,0,0,0-13.35-5.1,80.16,80.16,0,0,0-15.64-1.5,67.9,67.9,0,0,0-17.82,2.14,45.7,45.7,0,0,0-13.09,5.63A27.09,27.09,0,0,0,429,468a16.17,16.17,0,0,0-2.8,8.78q0,5.79,3.07,9t9.22,3.25q6.15,0,9.31-3.07a10.64,10.64,0,0,0,3.17-8,7.87,7.87,0,0,0-2.82-6.5,12.23,12.23,0,0,0-6.85-2.64,27.55,27.55,0,0,1,9.75-4.74,54.81,54.81,0,0,1,15-1.76,23,23,0,0,1,9.14,1.67,17.38,17.38,0,0,1,10.1,11.33,29.08,29.08,0,0,1,1.14,8.26v5.44q-7.72,2.12-15.54,3.52t-15.12,2.9q-7.29,1.49-13.7,3.34a40.73,40.73,0,0,0-11.24,5,23.58,23.58,0,0,0-7.56,7.82,22.89,22.89,0,0,0-2.72,11.68q0,11.6,7.64,18.36t24.16,6.76a50.22,50.22,0,0,0,12.83-1.58,44.25,44.25,0,0,0,10.71-4.31,37,37,0,0,0,8.17-6.23,29.77,29.77,0,0,0,5.36-7.38,39.41,39.41,0,0,0,1.93,6.68,17.48,17.48,0,0,0,3.51,5.61,17,17,0,0,0,5.62,4,19.79,19.79,0,0,0,8.08,1.49,27.85,27.85,0,0,0,7.82-1.05,15.21,15.21,0,0,0,6.23-3.52,15.7,15.7,0,0,0,4.05-6.51,30.49,30.49,0,0,0,1.4-9.86v-7.92h-8.25v10.38a11.61,11.61,0,0,1-1.23,5.37,4,4,0,0,1-3.69,2.38q-5.28,0-5.27-7.75Z"
				transform="translate(-0.07 -358.02)"
			/>
			<path
				className="logoCalvinEdition32"
				d="M354.77,364.51H326.29l-9.62,24q-11.18-12-33.3-21.24T230.05,358a173.5,173.5,0,0,0-57,9.17A128.37,128.37,0,0,0,126.7,394.9q-19.85,18.53-31.19,47T84.16,509q0,37.07,11.55,64.38t31.75,45.27a131.4,131.4,0,0,0,47.16,26.76,186.64,186.64,0,0,0,58.12,8.78q29.64,0,51.21-8.2t36.56-21.56A114.38,114.38,0,0,0,345,593.86a178.77,178.77,0,0,0,14.82-35.49L334,549.59q-10.39,33.58-33.5,52.09t-63.13,18.51a97,97,0,0,1-37.14-6.87,75.94,75.94,0,0,1-28.87-20.8q-12.14-13.92-18.86-35.1t-6.74-49.8a197.78,197.78,0,0,1,5.39-47.7q5.38-21.76,16.74-37.4a77.56,77.56,0,0,1,29.45-24.43q18.09-8.76,43.5-8.78,34.65,0,56.39,19.47t29.45,51.52l28.1-2.29Z"
				transform="translate(-0.07 -358.02)"
			/>
		</g>
	</svg>
);

const Titre = props => (
	<svg
		width={props.width || 40}
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 1280.26 173.78"
	>
		<defs>
			<style
				dangerouslySetInnerHTML={{
					__html:
						".Titre1{fill:none;}.Titre2{fill:#fff;}.Titre3{clip-path:url(#TitreCP);}.Titre4{fill:#2a292a;}"
				}}
			/>
			<clipPath id="TitreCP" transform="translate(0.26 -462.22)">
				<rect
					className="Titre1"
					x="-0.26"
					y="462.22"
					width="1280.26"
					height="173.78"
				/>
			</clipPath>
		</defs>
		<rect className="Titre2" width="1280.26" height="173.78" />
		<g className="Titre3">
			<path
				className="Titre4"
				d="M1113.84,597H1152V584.3h-24.16V557H1147V544.23h-19.2V520.7H1152V508h-38.15Zm-47.57,0h37V584.3h-23V508h-14Zm-47.57,0h37V584.3h-23V508h-14Zm-28.24,0h14V508h-14Zm-50,0h38.16V584.3H954.46V557h19.21V544.23H954.46V520.7h24.17V508H940.47Zm-42.61,0h18.57l13.49-89H917.07l-9.16,69.07h-.25L898.5,508H884.38Zm-59.78,0h38.16V584.3H852.07V557h19.21V544.23H852.07V520.7h24.17V508H838.08Zm11.45-95h10.56l13.6-14.63H858.43ZM797,546.14V520.7h6.36c5,0,7.12,2.79,7.12,9.15v6.87c0,7.13-3.18,9.42-8.4,9.42ZM783,597h14V558.85h4.83c6.36,0,8.78,2.68,8.78,10.94v16.29c0,7.25.5,8.64,1.27,10.93h14.24c-1.4-3.3-1.52-6.48-1.52-10.81V570.56c0-10-2.29-16.67-9.29-18.83v-.25c6.23-2.55,9.16-8.4,9.16-17.55v-5.48c0-13.73-6.23-20.47-20.73-20.47H783Zm-74.15,0H747V584.3H722.84V557h19.21V544.23H722.84V520.7H747V508H708.85Zm-32.94,1.28c13.74,0,21.11-8.14,21.11-22.64,0-11.07-3.69-18.19-15.39-28.5-9.16-8-12.08-12.72-12.08-19.2,0-6.11,2.54-8.53,7-8.53s7,2.42,7,8.78v4.58h13.23v-3.69c0-14.25-6.74-22.39-20.35-22.39s-20.86,8.14-20.86,22.14c0,10.17,3.81,17.42,15.51,27.73,9.16,8,12,12.71,12,20.09,0,6.62-2.8,8.91-7.25,8.91s-7.25-2.29-7.25-8.65v-6.11H655.3v5.09c0,14.25,6.87,22.39,20.61,22.39M583.56,597h38.16V584.3H597.56V557h19.2V544.23h-19.2V520.7h24.16V508H583.56Zm-72.24,0h12.21V529.6h.25L534,597h11.7l10.18-67.41h.25V597h13.23V508h-20l-8.9,63.72h-.26L531.29,508h-20Zm-41.09-50.87V520.7h6.36c5,0,7.13,2.79,7.13,9.15v6.87c0,7.13-3.18,9.42-8.4,9.42Zm-14,50.87h14V558.85h4.84c6.36,0,8.77,2.68,8.77,10.94v16.29c0,7.25.51,8.64,1.28,10.93h14.24c-1.4-3.3-1.53-6.48-1.53-10.81V570.56c0-10-2.29-16.67-9.28-18.83v-.25c6.23-2.55,9.16-8.4,9.16-17.55v-5.48c0-13.73-6.24-20.47-20.74-20.47H456.24Zm-34.47-11.44c-4.45,0-7.25-2.42-7.25-8.78V528.2c0-6.36,2.8-8.78,7.25-8.78s7.25,2.42,7.25,8.78v48.59c0,6.36-2.8,8.78-7.25,8.78m0,12.72c13.74,0,21.24-8.14,21.24-22.39V529.09c0-14.25-7.5-22.39-21.24-22.39s-21.24,8.14-21.24,22.39V575.9c0,14.25,7.5,22.39,21.24,22.39M354,597h14V558.22H386V545.5H368V520.7h23V508H354Zm-50,0h38.16V584.3H318V557h19.21V544.23H318V520.7h24.17V508H304Zm11.45-95H326l13.6-14.63H324.34ZM262.9,546.14V520.7h6.36c5,0,7.13,2.79,7.13,9.15v6.87c0,7.13-3.18,9.42-8.4,9.42Zm-14,50.87h14V558.85h4.84c6.36,0,8.77,2.68,8.77,10.94v16.29c0,7.25.51,8.64,1.28,10.93H292c-1.4-3.3-1.52-6.48-1.52-10.81V570.56c0-10-2.29-16.67-9.29-18.83v-.25c6.23-2.55,9.16-8.4,9.16-17.55v-5.48c0-13.73-6.23-20.47-20.74-20.47H248.91Zm-65.5-29.51,6.1-44h.26l6.23,44ZM166.24,597h13l2.55-17.42h15.89v-.25L200.2,597h14l-14.5-89H180.74Zm-44.39,0h37V584.3h-23V508h-14Z"
				transform="translate(0.26 -462.22)"
			/>
		</g>
	</svg>
);

const Youtube = props => (
	<svg
		width={props.width || 40}
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 1021 1024"
	>
		<defs>
			<style
				dangerouslySetInnerHTML={{
					__html:
						".youtube1{fill:none;}.youtube2{clip-path:url(#youtubeCP);}.youtube3{fill:#fff;}"
				}}
			/>
			<clipPath id="youtubeCP">
				<rect
					className="youtube1"
					x="-0.37"
					y={1}
					width="1021.37"
					height="1021.37"
				/>
			</clipPath>
		</defs>
		<g className="youtube2">
			<path
				className="youtube3"
				d="M447.89,595l163.37-88.26-89.74-48.85-73.67-40.1v41.32Zm364.89-58c0,51.09-6.07,102.12-6.07,102.12s-5.89,43.45-24,62.6c-23,25.13-48.81,25.25-60.58,26.73-84.71,6.33-211.79,6.57-211.79,6.57s-157.27-1.53-205.68-6.35c-13.41-2.61-43.66-1.82-66.72-26.94-18.09-19.12-24-62.59-24-62.59s-6.06-51-6.06-102.14V489.11c0-51.06,6.06-102.09,6.06-102.09s5.93-43.48,24-62.63c23.06-25.1,48.8-25.27,60.62-26.69,84.63-6.37,211.64-6.37,211.64-6.37h.27s127,0,211.66,6.35c11.77,1.44,37.56,1.61,60.58,26.7,18.12,19.12,24,62.63,24,62.63s6.07,51,6.07,102.1v47.81ZM1021,511.68C1021,229.66,792.37,1,510.33,1S-.37,229.66-.37,511.68s228.64,510.7,510.7,510.7S1021,793.73,1021,511.68"
			/>
		</g>
	</svg>
);

const Twitter = props => (
	<svg
		width={props.width || 40}
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 1021 1024"
	>
		<defs>
			<style
				dangerouslySetInnerHTML={{
					__html:
						".Twitter1{fill:none;}.Twitter2{clip-path:url(#TwitterCP);}.Twitter3{fill:#fff;}"
				}}
			/>
			<clipPath id="TwitterCP">
				<rect className="Twitter1" y="-0.01" width={1021} height="1021.02" />
			</clipPath>
		</defs>
		<g className="Twitter2">
			<path
				className="Twitter3"
				d="M771,328.29l80.42-23.8-73.63,78.27c0,6.47-.15,13-.45,19.34,0,.87,0,1.79,0,2.66,0,215.83-175,390.85-390.84,390.85-1.48,0-3,0-4.44-.05a388.39,388.39,0,0,1-212.48-65.71c117.89,11.29,191.14-55.76,191.14-55.76C260,667.41,231.13,572.92,231.13,572.92c26.8,9.55,60.59-2.56,60.59-2.56-119.3-37-112.3-139.11-112.3-139.11,28.89,19.82,60.64,16.18,60.64,16.18-98.68-95.3-37.57-187.2-37.57-187.2,128,150.54,279.39,150.35,296.76,149.84a144.78,144.78,0,0,1-5.67-25,120,120,0,0,1,7.2-66.88,141,141,0,0,1,241.87-40.8c2.86,2.06,4.49,3.27,4.49,3.27a30.6,30.6,0,0,0,9.5-1.79c26.34-8.46,68.81-44.81,68.81-44.81Zm250,182.23v0C1021,228.56,792.44,0,510.51,0h0C228.56,0,0,228.56,0,510.5v0C0,792.45,228.56,1021,510.49,1021h0c281.93,0,510.5-228.57,510.5-510.5"
			/>
		</g>
	</svg>
);

class SlideTemplate1 extends React.Component {
	wallpaper() {
		return (
			<figure
				className="figureReactBackgroundSlider"
				style={{
					backgroundImage:
						"url(" +
						`${tools.lienCalvinEdition}/header/${this.props.slide.image}` +
						")",
					maxHeight: "900px",
					backgroundSize: "auto",
					marginTop: "90px"
				}}
			/>
		);
	}

	render() {
		const data = this.props.slide;
		const { t } = this.props;

		return (
			<>
				<section style={{ height: " 766px" }}>
					<div id="ReactBackgroundSlider">{this.wallpaper()}</div>
					<div className="container-fluid no-gutters">
						<div className="row no-gutters" style={{ marginTop: "50px" }}>
							<div className="col-xl-2 col-lg-1 no-gutters" style={{}}></div>
							<div className="col-xl-8 col-lg-12">
								<div className="text-center mb-5 pt-5">
									<div className="text-center" style={{ paddingTop: "60px" }}>
										<div style={{ position: "relative" }}>
											<div className="d-block d-md-none">
												<Link to="/">
													<div>
														<LogoCalvinEdition width={"270px"} color="#fff" />
													</div>
													<span
														style={{
															position: "absolute",
															marginTop: "-13px",
															marginLeft: "-38px"
														}}
													>
														<Titre width={"200px"} />
													</span>
												</Link>
											</div>

											<div className="d-none d-md-block no-gutters">
												<Link to="/">
													<div>
														<LogoCalvinEdition width={"600px"} color="#fff" />
													</div>
													<span
														style={{
															position: "absolute",
															marginTop: "-19px",
															marginLeft: "-80px"
														}}
													>
														<Titre width={"437px"} />
													</span>
												</Link>
											</div>

											<div
												className="text-white"
												style={{
													minWidth: "330px",
													maxWidth: "950px",
													paddingTop: "70px",
													position: "absolute",
													left: "50%",
													transform: "translate(-50%, 0)"
												}}
											>
												<p className="text-center" style={{}}>
													<h3 className="ft-lato-light" style={{}}>
														Calvin éditions est une maison d’édition protestante
														créée en 2020. Par ses publications, elle souhaite
														faire vivre l’héritage de la Réforme et du Réveil.
													</h3>
												</p>
												<div style={{ paddingTop: "50px" }}>
													<Link
														to={"/catalogue/reforme-et-reveil"}
														style={{
															textDecoration: "none"
														}}
													>
														<span className="text-center mt-5 ft-ubuntu text-uppercase slideTemplate1 nosCollections">
															NOS COLLECTIONS
														</span>
													</Link>
													<div
														style={{
															paddingTop: "30px",
															color: "#aaa",
															fontSize: "1.5em"
														}}
													></div>
													{/* <div style={{ paddingTop: '30px', color: '#aaa', fontSize: '1.5em' }}>contact@calvineditions.fr</div> */}

													<div className="pt-3"></div>
													<a
														href="https://www.youtube.com/channel/UCSJxpLKm3min0LuN8P0hQqg/featured"
														target="_blank"
														className="logoYoutube"
													>
														<Youtube width={50} />
													</a>
													<span className="pl-4"></span>
													<a
														href="https://twitter.com/CalvinEditions?s=09"
														target="_blank"
														className="logoTwitter"
													>
														<Twitter width={50} />
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-2 col-lg-1 no-gutters" style={{}}></div>
						</div>
					</div>
				</section>
			</>
		);
	}
}
export default withTranslation()(SlideTemplate1);
